import { render, staticRenderFns } from "./SelfPageLikes.vue?vue&type=template&id=7531e6e0&scoped=true&"
import script from "./SelfPageLikes.vue?vue&type=script&lang=js&"
export * from "./SelfPageLikes.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=7531e6e0&lang=css&scoped=true&"
import style1 from "./SelfPageLikes.vue?vue&type=style&index=1&id=7531e6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531e6e0",
  null
  
)

export default component.exports